// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SeatListModal__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AirlineSeatSelection/SeatListModal.scss
 ** module id = 878
 ** module chunks = 1
 **/